// Get Account
export const GET_ACCOUNT_REQUEST = 'GET_ACCOUNT_REQUEST';
export const GET_ACCOUNT_DONE = 'GET_ACCOUNT_DONE';
export const GET_ACCOUNT_FAILED = 'GET_ACCOUNT_FAILED';

export const UPDATE_AVATAR_URL = 'UPDATE_AVATAR_URL';